import { useQuery } from '@apollo/client';
import { Reports } from '@otp/icons';
import { Card, Typography } from '@otp/ui';
import { DocumentNode } from 'graphql';
import { useState } from 'react';
import { Reload } from '@otp/icons';

export type Report = {
  id: string;
  name: string;
  description?: string;
  document: DocumentNode;
  key: string;
};

type CardProps = {
  report: Report;
};

export const ReportCard = ({
  report: { name, description, document, key },
}: CardProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const { data } = useQuery(document, {
    fetchPolicy: 'network-only',
    skip: !isLoading,
    onCompleted: (data) => {
      setIsLoading(false);

      const url = data[key];

      url && window.open(url, '_blank');
    },
  });

  const onClick = () => {
    setIsLoading(true);
  };

  return (
    <Card
      className="flex flex-col h-auto w-auto"
      isLink={true}
      onClick={onClick}
    >
      <div className="flex items-center gap-2 mb-3">
        <Reports />
        <Typography variant="subtitle1">{name}</Typography>
        {isLoading && <Reload className="animate-spin" />}
      </div>

      {description && (
        <Typography variant="subtitle2" className="text-primary-500">
          {description}
        </Typography>
      )}
    </Card>
  );
};
